import { useMemo } from 'react';
import AppointmentIcon from 'components/atoms/icons/appointmentIcon';
import FileIcon from 'components/atoms/icons/fileIcon';
import TelemedIcon from 'components/atoms/icons/telemedIcon';
import { startTelemed } from 'utils';

const useRequestButtons = ({
  patientDetailsLoading,
  profile,
  appointmentSubmitLoading,
  sendAppointmentRequest,
  isRpmPanel,
  setDischargePopupOpen,
  dischargeSubmitLoading,
  getPatientLoading,
  patient,
}) => {
  const requestButtons = useMemo(
    () => [
      {
        render: true,
        label:
          patientDetailsLoading || profile.appointmentsFlagActive
            ? 'Request Appointment'
            : 'Appointment Requested',
        icon: AppointmentIcon,
        handleClick: () => sendAppointmentRequest(),
        disabled:
          patientDetailsLoading ||
          !profile.appointmentsFlagActive ||
          appointmentSubmitLoading,
      },
      {
        render: isRpmPanel,
        label: patientDetailsLoading
          ? 'Request Discharge'
          : 'Discharge Requested',
        icon: FileIcon,
        handleClick: () => setDischargePopupOpen(true),
        disabled:
          getPatientLoading ||
          patientDetailsLoading ||
          dischargeSubmitLoading ||
          patient?.profile?.status !== 'active',
      },
      {
        render: true,
        label: 'Start telemed',
        icon: TelemedIcon,
        handleClick: () => startTelemed(),
      },
    ],
    [
      patientDetailsLoading,
      profile,
      appointmentSubmitLoading,
      dischargeSubmitLoading,
      patient,
    ],
  );

  return requestButtons;
};

export default useRequestButtons;
